import React, {Component} from 'react';
import * as THREE from 'three';

import {loadModel} from '../Model';

const BIOME_STONE = "PUSHILIN_stone",
    BIOME_GRASS = "PUSHILIN_grass",
    BIOME_POLAR_TREE = "SpruceTree",
    BIOME_TEMPERATE_TREE = "OakTree",
    BIOME_TROPICAL_TREE = "BloodwoodTree",
    BIOME_EQUATORIAL_TREE = "DatePalmTree",
    BIOME_VILLAGE = "SM_Cabana_02";

export default class PlanetBiome extends Component {

    componentDidMount() {
        const {biomeId, point, altitude, random} = this.props;
        this.loadModel(biomeId, point, altitude, random);
    }

    componentWillReceiveProps({biomeId, point, altitude, random}) {
        if (point !== this.props.point) {
            this.removeModel();
            this.loadModel(biomeId, point, altitude, random);
        } else if (this.name && altitude !== this.props.altitude) {
            const length = altitude + this.getBiomeOffset(this.name);
            this
                .model
                .position
                .setLength(length);
        }
    }

    shouldComponentUpdate() {
        return false;
    }

    componentWillUnmount() {
        this.removeModel();
    }

    loadModel = (biomeId, point, altitude, random) => {
        const {group} = this.refs,
            names = this.getBiomeNames(biomeId, random);
        this.name = names && this.getBiomeName(names, random);
        if (this.name) {
            loadModel(this.name).then(object => {
                const normal = new THREE.Vector3(...point),
                    length = altitude + this.getBiomeOffset(this.name);
                this.model = object.clone();
                this
                    .model
                    .rotation
                    .set(
                        object.up.x * random * Math.PI * 2 * names.length,
                        object.up.y * random * Math.PI * 2 * names.length,
                        object.up.z * random * Math.PI * 2 * names.length
                    );
                this
                    .model
                    .scale
                    .set(1 + random, 1 + random, 1 + random);
                this
                    .model
                    .position
                    .copy(object.up)
                    .setLength(length)
                group
                    .quaternion
                    .setFromUnitVectors(object.up, normal);
                group.add(this.model);
            });
        }
    }

    removeModel = () => {
        const {group} = this.refs;
        if (this.model) {
            group.remove(this.model);
            delete this.model;
        }
    }

    getBiomeName = (names, random) => {
        const n = Math.min(Math.floor(random * names.length), names.length - 1);
        return names[n];
    }

    getBiomeNames = (biomeId) => {
        switch (biomeId) {
            case 'polar-0':
                return [BIOME_POLAR_TREE, BIOME_STONE, null];
            case 'polar-1':
                return [BIOME_POLAR_TREE, BIOME_VILLAGE, null];
            case 'polar-2':
                return [BIOME_POLAR_TREE, BIOME_TEMPERATE_TREE, BIOME_STONE];
            case 'polar-3':
                return [BIOME_POLAR_TREE, BIOME_VILLAGE];
            case 'temperate-0':
                return [BIOME_TEMPERATE_TREE, BIOME_VILLAGE, null];
            case 'temperate-1':
                return [BIOME_TEMPERATE_TREE, BIOME_TROPICAL_TREE, BIOME_GRASS];
            case 'temperate-2':
                return [BIOME_TEMPERATE_TREE, BIOME_VILLAGE];
            case 'temperate-3':
                return [BIOME_TEMPERATE_TREE, BIOME_POLAR_TREE, BIOME_GRASS];
            case 'tropical-0':
                return [BIOME_TROPICAL_TREE, BIOME_EQUATORIAL_TREE, BIOME_STONE];
            case 'tropical-1':
                return [BIOME_TROPICAL_TREE, BIOME_VILLAGE];
            case 'tropical-2':
                return [BIOME_TROPICAL_TREE, BIOME_TEMPERATE_TREE, BIOME_STONE];
            case 'tropical-3':
                return [BIOME_TROPICAL_TREE, BIOME_VILLAGE, null];
            case 'equatorial-0':
                return [BIOME_EQUATORIAL_TREE, BIOME_VILLAGE];
            case 'equatorial-1':
                return [BIOME_EQUATORIAL_TREE, BIOME_TROPICAL_TREE, BIOME_GRASS];
            case 'equatorial-2':
                return [BIOME_EQUATORIAL_TREE, BIOME_VILLAGE, null];
            case 'equatorial-3':
                return [BIOME_EQUATORIAL_TREE, BIOME_GRASS, null];
            default:
                return null;
        }
    }

    getBiomeOffset = (name) => {
        switch (name) {
            case BIOME_STONE:
            case BIOME_GRASS:
                return -0.1;
            case BIOME_TROPICAL_TREE:
                return -0.2;
            case BIOME_TEMPERATE_TREE:
            case BIOME_POLAR_TREE:
            case BIOME_EQUATORIAL_TREE:
                return -0.3;
            case BIOME_VILLAGE:
                return -0.8;
            default:
                return 0;
        }
    }

    render() {
        return <group ref="group"/>;
    }
}


// WEBPACK FOOTER //
// ./src/apps/scene-planet/scene/planet/biome.js